import Vue from 'vue'
import Message from './message.vue'
let MessageCtor = Vue.extend(Message)
let instances = []
const fixedVerticalOffset = 16
const message = function (options) {
  if (typeof window === 'undefined') return
  options = options || {}
  let verticalOffset = 0
  if (instances.length === 0) {
    verticalOffset = fixedVerticalOffset + (options.offset || 0)
  } else {
    verticalOffset = instances[instances.length - 1].$el.offsetTop + instances[instances.length - 1].$el.offsetHeight + fixedVerticalOffset
  }
  options.verticalOffset = verticalOffset
  let instance = new MessageCtor({ data: options })
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.visible = true
  instance.onClose = function () {
    instances.shift()
  }
  instances.push(instance)
}
export default message
